import type { OfferConfig } from "@/types/offer";
import { obligationsExportOffer } from "./obligations-export";
import { sopCoverageOffer } from "./sop-coverage";

const registry: Record<string, OfferConfig> = {
  [obligationsExportOffer.offerId]: obligationsExportOffer,
  [sopCoverageOffer.offerId]: sopCoverageOffer,
};

export function getOffer(offerId: string | undefined): OfferConfig | undefined {
  if (!offerId) return undefined;
  return registry[offerId];
}

export function listOffers(): OfferConfig[] {
  return Object.values(registry);
}

export { obligationsExportOffer, sopCoverageOffer };
